import styled from 'styled-components';
import { rem, device } from '../lib/global-styles';

export const NavButtons = styled.div`
  text-align: right;
  margin-top: ${rem(20)};

  button {
    display: inline-block;
    margin: 0;
    margin-left: ${rem(20)};
  }

  button[type='submit'] {
    padding-left: ${rem(50)};
    padding-right: ${rem(50)};
  }

  @media ${device.mobile} {
    padding: 0 ${rem(20)};
    margin: ${rem(20)} auto;
  }
`;
